const mySmartCatalogCourseDetailStates = {
  url: 'smart_course_details/:courseNk',
  data: {
    pageTitle: 'Course Details',
    academicPlanUrl: 'reg/academicplan'
  },
  params: {
    courseDetails: {}
  }
};

export const MySmartCatalogRoutes = {
  'my.planner.plan.default.smart_course_details': {
    ...mySmartCatalogCourseDetailStates,
    data: {
      pageTitle: 'My Planner Search',
      academicPlanUrl: 'reg/academicplan'
    },
    views: {
      'right-panel-popout@my.planner.plan': {
        template: `<ap-course-details></ap-course-details>`
      }
    }
  }
};
export const AdvisorSmartCatalogRoutes = {
  'ap-advisor.plan.edit.default.smart_course_details': {
    ...mySmartCatalogCourseDetailStates,
    data: {
      pageTitle: 'Advisor Smart Search',
      academicPlanUrl: 'reg/advisorplan'
    },
    views: {
      'right-panel-popout@ap-advisor.plan.edit': {
        template: `<ap-course-details></ap-course-details>`
      }
    }
  },
  'ap-advisor.plan.view.default.smart_course_details': {
    ...mySmartCatalogCourseDetailStates,
    data: {
      pageTitle: 'Advisor Smart Search',
      academicPlanUrl: 'reg/advisorplan'
    },
    views: {
      'right-panel-popout@ap-advisor.plan.view': {
        template: `<ap-course-details hide-actions="true"></ap-course-details>`
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_smart_catalog_routes.ts